import any_file_logo from "./any-file-icon.svg";
import pdf_logo from "./pdf-file-icon.png";
import ms_word_logo from "./docx-file-icon.svg";
import ms_excel_logo from "./xls-file-icon.svg";

const ChooseFileIcon = (docName) => {
  let fileNamePart = docName.split(".");
  let fileExtension = fileNamePart[fileNamePart.length - 1];

  if (fileExtension === "pdf") {
    return pdf_logo;
  } else if (fileExtension === "doc" || fileExtension === "docx") {
    return ms_word_logo;
  } else if (
    fileExtension === "csv" ||
    fileExtension === "xls" ||
    fileExtension === "xlsx"
  ) {
    return ms_excel_logo;
  } else {
    return any_file_logo;
  }
};

export default ChooseFileIcon;
